import ForgetPasswordForm from '../Components/Forms/ForgetPasswordForm'
import React from 'react'

export const ForgetPassword = () => {
  return (
   <ForgetPasswordForm/>
  )
}
